/* istanbul ignore file */

import { VirtualizationSettings } from '@progress/kendo-angular-dropdowns';
import { Project, User } from '../../../models';

export class ProjectsServiceModel {
    currentProject: Project;
    exportingLayout: boolean;
    isSaving: boolean;
    lastRegularProjectId: string | null;
    project: Project;
    projectAdmins: User[];
    projectLoading: boolean;
    projectsLoading: boolean;
    projectPreview: Project;
    projects: Project[];
    adminProjects: Project[];
    savingOrPublishing: boolean;
    uploadingLayout: boolean;
    virtualizationSettings: VirtualizationSettings;
}
